import createApp from 'commons/fleet/createApp';
import { router } from 'launchpad/containers/App/AppRouter';

import { MONITORING } from './constants';

const renderApp = () =>
  createApp({
    name: 'launchpad',
    router,
    moduleToWatch: 'launchpad/containers/App',
    monitoring: MONITORING,
  });

if (module.hot) {
  module.hot.accept('launchpad/containers/App', () => {
    // eslint-disable-next-line global-require
    renderApp();
  });
}
renderApp();
